var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TAILWIND !block relative",staticStyle:{"display":"none"},attrs:{"id":"tailwind"}},[_c('div',{staticClass:"text-base min-h-screen flex flex-col relative"},[_c('Navbar',{staticClass:"shrink-0"}),_c('router-view',{staticClass:"grow bg-gray-50 relative flex"}),_c('ActionToast'),_c('ContainerOptions')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }